import { Component } from '@angular/core';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { ClientService } from '../components/client.service';
import { MyInfo } from '../data';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChanguePassClientComponent } from './changue-pass-client/changue-pass-client.component';
import Swal from 'sweetalert2';
import { UpdateInfoClientComponent } from './update-info-client/update-info-client.component';

@Component({
  selector: 'app-client-info',
  templateUrl: './client-info.component.html',
  styleUrls: ['./client-info.component.scss']
})
export class ClientInfoComponent {
  public cargando = true;
  public icons = { faPen };
  public clientId: number;
  public myInfo: MyInfo;
  public requiereChanguePass: boolean;

  constructor(private authService: AuthService, private clientService: ClientService, private dialog: MatDialog,) {
    this.clientId =  parseInt(this.authService.getRutUser());
    this.requiereChanguePass = this.authService.changePass();
  } 

  ngOnInit() {
    this.obtenerMyInfo();
    this.changuePassConsult();
  }

  public changuePassConsult() {
    if(this.requiereChanguePass) {
      Swal.fire({
        title: 'Favor, cambia tu contraseña',
        icon: 'info',
        showConfirmButton: true,
        confirmButtonText: 'Cerrar'
      });
    }
  }

  public obtenerMyInfo() {
    this.clientService.getMyInfo().subscribe({
      next: (response) => {
        this.cargando = false;
        this.myInfo = response;
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  public openModalChanguePassClient() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '50vw';
    dialogConfig.height = '46vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = this.clientId;

    this.dialog.open(ChanguePassClientComponent, dialogConfig);
  }

  public openUpdateInfoClientComponent(type: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '40vw';
    dialogConfig.height = '35vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = {
      clientId: this.clientId,
      type: type
    };
  
    const dialogRef = this.dialog.open(UpdateInfoClientComponent, dialogConfig);
  
    // Suscribirse al evento de cierre del diálogo
    dialogRef.afterClosed().subscribe(result => {
      this.updatePageInfoClient();
    });
  }

  public updatePageInfoClient() {
    this.obtenerMyInfo();
  }

}
